import calc from "../assets/images/calc.svg"
import clock from "../assets/images/clock.svg"
import { useContext, useState } from "react"
import { DataContext } from "../index"
import DatePicker, { DateObject } from "react-multi-date-picker";

function CryptoTable() {
    const dataContext = useContext(DataContext)
    const [showCal, setShowCal] = dataContext.showCalc;
    const updatedAt=new DateObject({ calendar: "persian" },dataContext.cryptoPrice.time*1000).format(
        "YYYY/MM/DD HH:mm:ss",
        ["Date", "Time"]
      )
    return (
        <>
            <div className="crypto-table-container">
                <div className="crypto-table-header">
                    <div className="table-header-bg-crypto"></div>
                    <section className="crypto-table-label"> نرخ ارز دیجیتال</section>
                    <section className="table-status">
                        <span className="last-update-label">
                            <span> آخرین بروزرسانی </span>
                            <span><img src={clock} /></span>
                        </span>
                        <span className="last-update-time">
                            <span>
                               {updatedAt.split(" ")[1]}
                            </span>
                            <span>
                            {updatedAt.split(" ")[0]}
                            </span>
                        </span>
                        <span className="calculator" onClick={() => {
                            setShowCal(!showCal)
                        }}>
                            <span>ماشین حساب</span>
                            <span ><img src={calc} /></span>
                        </span>
                    </section>
                </div>
                <table className="crypto-table">
                    <thead>
                        <tr>
                            <th>
                            </th>
                            <th>
                                ارز
                            </th>
                            <th>
                                فروش
                            </th>

                        </tr>
                    </thead>
                    {
                        Object.keys(dataContext?.cryptoPrice).map((item, i) => {
                            return (i !== 4 ? (<tr>
                                <td style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <img className={`flag`} src={`/flags/crypto/${item}.png`} />
                                </td>
                                <td className={``}>{item}</td>
                                <td className={`price green-price`}>{Object.values(dataContext.cryptoPrice)[i]}</td>

                            </tr>) : null)
                        })
                    }
                </table>
            </div>
        </>
    )
}

export default CryptoTable;